import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Usuario, Usuario2, DatosUsuario } from '../../models/usuario.model';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class UsuarioService {

  token: string;
  idUsuario: string;
  path: string =  environment.URL_SERVICIOS.replace('/api/v1','');
  // this.path =  environment.URL_SERVICIOS.replace('/api/v1','')
  public datosusuario: DatosUsuario
  constructor(
    public http: HttpClient,
    public router: Router
  ) {
    this.cargarStorage();
  }

  estaLogueado() {
   let stringExpiraToken = localStorage.getItem('expiratoken');
   if (stringExpiraToken !== null) {
    stringExpiraToken = stringExpiraToken.substring(0, 10);
   const fechaExpiraToken = Date.parse(stringExpiraToken);
   const fechaHoy = new Date();
   const fechaHoyA = fechaHoy.getFullYear().toString();
   let fechaHoyM = (fechaHoy.getMonth() + 1).toString();
   let fechaHoyD = fechaHoy.getDate().toString();

   if ( fechaHoyM.length === 1 ) {
    fechaHoyM = ( '0' + fechaHoyM );
   }

   if ( fechaHoyD.length === 1 ) {
    fechaHoyD = ( '0' + fechaHoyD );
   }

   const fechaHoyC = Date.parse(fechaHoyA + '-' + fechaHoyM + '-' + fechaHoyD);

   
    if ( fechaExpiraToken > fechaHoyC ) {
      this.getusuario(localStorage.getItem('uid')).subscribe( resp => {
        this.datosusuario = new DatosUsuario(resp[0].id,'','','','');
      } )
      return true;
    }
   else {
      localStorage.clear();
      return false;
  }
   } else {
    localStorage.clear();
    return false
   }
   
}

  cargarStorage() {

    if ( localStorage.getItem('tkn')) {
      this.token = localStorage.getItem('tkn');
    } else {
      this.token = '';
    }

  }

  logout() {
    localStorage.clear();
  }

  getCustomerxidu(idu: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/customer_user_association?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get( url )
                .map( (resp: any) => {
                  return resp;
                });
  }

  getGovSupervisorUsers() {
    const url = `${environment.URL_SERVICIOS}/get_supervisor_users?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get( url )
                .map( (resp: any) => {
                  return resp;
                });
  }

  guardarStoragelogin( id: string, token: string, email: string,name: string, expiratoken: string, roleid: string, company_signatory: string ) {

    localStorage.setItem('uid', id );
    localStorage.setItem('tkn', token );
    localStorage.setItem('emailuser', email );
    localStorage.setItem('nombreuser', name );
    localStorage.setItem('expiratoken', expiratoken);
    localStorage.setItem('rid', roleid);
    localStorage.setItem('firmante', company_signatory);
   // localStorage.setItem('user_options', JSON.stringify(relations));

    this.token = token;
  }

  login( correo, pass ) {
    const url = `${environment.URL_SERVICIOS}/authenticate?auth[email]=${correo}&auth[password]=${pass}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get( url )
                .map( (resp: any) => {
                  return resp;
                });
  }

  crearArregloData( Obj: any) {
    const arr: any[] = [];
    const resul: any[] = [];
    if ( Obj === null ) { return []; }
    Object.keys ( Obj ).forEach( key => {
      const fo: any = Obj[key];
      arr.push( fo );
    });
    resul.push( arr[0].attributes );
    return resul;
}

  getusuario( idu ) {
    const url = `${environment.URL_SERVICIOS}/users/${idu}?token=${this.token}&secret_key=${environment.SECRET_KEY}`
    return this.http.get( url ).pipe(
      map( (resp: any) => {return this.crearArregloData(resp);
      }));
  }

  getrol(idr) {
    const url = `${environment.URL_SERVICIOS}/roles/${idr}?token=${this.token}&secret_key=${environment.SECRET_KEY}`
    return this.http.get( url ).pipe(
      map( (resp: any) => {return resp;
      }));
  }

  getUsuarios() {

    const url = `${environment.URL_SERVICIOS}/users?secret_key=${environment.SECRET_KEY}&token=${this.token}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return this.crearArregloUsuarios(resp);
    }));

  }

  getAllUsers() {

    const url = `${environment.URL_SERVICIOS}/get_all_users_with_company_signatories?secret_key=${environment.SECRET_KEY}&token=${this.token}`;

    return this.http.get( url ).pipe(

    map( (resp: any) => {return resp.users;
    }));

  }

  getUsuariosFirmantesEmpresa() {

    const url = `${environment.URL_SERVICIOS}/company_signatory/users_company_signatories?secret_key=${environment.SECRET_KEY}&token=${this.token}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return resp.user_signatories;
    }));

  }

  getUserCompanySignatories(uid) {

    const url = `${environment.URL_SERVICIOS}/get_user_company_signatories?secret_key=${environment.SECRET_KEY}&token=${this.token}&id=${uid}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {if (resp.data[0]) {return resp.data[0].companies_info;} else {return []}
    }));

  }

  getGovCustomers(uid) {

    const url = `${environment.URL_SERVICIOS}/get_all_gov_customers?secret_key=${environment.SECRET_KEY}&token=${this.token}&user_id=${uid}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return resp;
    }));

  }

  getGovCustomer(id) {

    const url = `${environment.URL_SERVICIOS}/get_gov_customer_info?secret_key=${environment.SECRET_KEY}&token=${this.token}&gov_customer_id=${id}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return resp;
    }));

  }

  getUsuariosSinCustomer() {

    const url = `${environment.URL_SERVICIOS}/reports/get_users_without_customer?secret_key=${environment.SECRET_KEY}&token=${this.token}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return resp;
    }));

  }

  getUsuariosConCustomer() {

    const url = `${environment.URL_SERVICIOS}/reports/get_users_with_customer?secret_key=${environment.SECRET_KEY}&token=${this.token}`;

    return this.http.get( url ).pipe(
    map( (resp: any) => {return resp;
    }));

  }

  borrarUsuario(id: string) {

    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
  
    const url = `${ environment.URL_SERVICIOS }/users/${ id }?`;
  
    return this.http.delete( url, {params} ).pipe(
      map( (resp: any) => { return resp;
        } ));
  
  }

  eliminarFirmanteEmpresa(id: string) {

    const params = {
      token: this.token,
      secret_key: environment.SECRET_KEY
    }
  
    const url = `${ environment.URL_SERVICIOS }/company_signatories/${ id }?`;
  
    return this.http.delete( url, {params} ).pipe(
      map( (resp: any) => { return resp;
        } ));
  
  }

  getCustomer( idu ) {
    const url = `${environment.URL_SERVICIOS}/users/${idu}?token=${this.token}&secret_key=${environment.SECRET_KEY}`
    return this.http.get(url);
    // return this.http.get( url ).pipe(
    //   map( (resp: any) => {return resp;
    //   }));
  }

    crearArregloUsuarios( usuariosObj: any) {

      const usuarios: any[] = [];
      const resul: any[] = [];
  
      if ( usuariosObj === null ) { return []; }
      Object.keys ( usuariosObj ).forEach( key => {
        const usuario: any = usuariosObj[key];
        usuarios.push( usuario );
      });
      // tslint:disable-next-line: forin
      for (const prop in usuarios[0]) {
    //  console.log( usuarios[0][prop].attributes );
      resul.push( usuarios[0][prop].attributes );
      }
  
    //  console.log(resul);
  
      return resul;
  
  }

  actualizaUsuario(id, params) {
    params.token = this.token;
    params.secret_key = environment.SECRET_KEY;
    const url = `${environment.URL_SERVICIOS}/users/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.patch( url, params ).pipe(
      map( (resp: any) => { return resp;
      } ));
    }

  actualizaUsuarioStatus(id, params) {
      params.secret_key = environment.SECRET_KEY;
      console.log(params);
      console.log(id)
      const url = `${environment.URL_SERVICIOS}/users/${id}?secret_key=${environment.SECRET_KEY}&auth[status]=${params.status}`;
      
      return this.http.patch( url, null ).pipe(
        map( (resp: any) => { return resp;
        } ));
      }  

  getUsuarioOptions( id: string ) {

      const url = `${environment.URL_SERVICIOS}/users/${id}?secret_key=${environment.SECRET_KEY}&token=${this.token}`;
    
      return this.http.get( url ).pipe(
        map ( (resp: any) => { return this.crearArregloUsuarioOptions(resp);
        } ));
    
    }

    crearArregloUsuarioOptions( usuariosObj: any) {

      const usuarios: any[] = [];
      const resul1: any[] = [];
      const resul2: any[] = [];
      if ( usuariosObj === null ) { return []; }
    
      // tslint:disable-next-line: forin
      for (const prop in usuariosObj.data.relations.options) {
        //  resul.push( usuariosObj.data.relations.options[prop].attributes );
        resul1.push (usuariosObj.data.relations.options[prop].attributes);
        resul2.push (usuariosObj.data.relations.user_options[prop].attributes);
    
          }
      // tslint:disable-next-line: forin
      for (const prop in resul2) {
    
        const iduo = resul2[prop].option_id;
    
          // tslint:disable-next-line: forin
        for (const prap in resul1) {
    
          const ido = resul1[prap].id;
    
          if ( iduo === ido ) {
    
            resul2[prop].name = resul1[prap].name;
    
          }
    
    
          }
    
      }
      return resul2;
    
    }

    getUserGender() {
      const params = new HttpParams () 
      .set ('token', this.token)
      .set ('secret_key', environment.SECRET_KEY); 
      const url = `${environment.URL_SERVICIOS}/lists/domain/USER_GENDER?secret_key=${environment.SECRET_KEY}&token=${this.token}`;   
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return this.crearArregloList(resp);
        } )
      );
    
    }
  
    getUserStatus() {
      const params = new HttpParams () 
      .set ('token', this.token)
      .set ('secret_key', environment.SECRET_KEY); 
      const url = `${environment.URL_SERVICIOS}/lists/domain/USER_STATUS?secret_key=${environment.SECRET_KEY}&token=${this.token}`;
      return this.http.get(url).pipe(
        map( (resp: any) => {
          return this.crearArregloList(resp);
        } )
      );
    
    }
    
    crearArregloList( contribuObj: any) {
    
      const rr: any[] = [];
      const resul: any[] = [];
    
      if ( contribuObj === null ) { return []; }
      Object.keys ( contribuObj ).forEach( key => {
        const rol: any = contribuObj[key];
        rr.push( rol );
      });
      // tslint:disable-next-line: forin
      for ( const prop in rr[0] ) {
    
        resul.push( rr[0][prop].attributes.value );
    
      }
    
      return resul;
    
    }

    crearUsuario( usuario: Usuario2 ) {
      let params = new URLSearchParams();

      params.set('auth[email]', usuario.email);
      params.set('auth[password]', usuario.password);
      params.set('auth[name]', usuario.nombre);
      params.set('auth[job]', usuario.puesto);
      params.set('auth[gender]', usuario.genero);
      params.set('auth[status]', usuario.estatus);
      params.set('auth[role_id]', usuario.rol);
      params.set('auth[company_signatory]', usuario.firmante);
      
      if (usuario.supervisor) {
        params.set('auth[user_supervisor_id]', usuario.supervisor);
      }

      params.set('token', this.token);
      params.set('secret_key', environment.SECRET_KEY);

      const url = `${environment.URL_SERVICIOS}/users?${params.toString()}`;
      

      // const url = `${environment.URL_SERVICIOS}/users?auth[email]=${usuario.email}&auth[password]=${usuario.password}&auth[company_id]=${usuario.company}&auth[name]=${usuario.nombre}&auth[job]=${usuario.puesto}&auth[gender]=${usuario.genero}&auth[status]=${usuario.estatus}&auth[role_id]=${usuario.rol}&auth[company_signatory]=${usuario.firmante}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  
  
      return this.http.post( url, null ).pipe(
                map( (resp: any) => {
                  return resp;
                }));
    }

    crearFirmanteEmpresa( data ) {
      let params = new URLSearchParams();

      params.set('company_signatories[user_id]', data.user_id);
      params.set('company_signatories[company_id]', data.company_id);

      params.set('token', this.token);
      params.set('secret_key', environment.SECRET_KEY);

      const url = `${environment.URL_SERVICIOS}/company_signatories?${params.toString()}`;
      
      return this.http.post( url, null ).pipe(
                map( (resp: any) => {
                  return resp;
                }));
    }

    crearEmpleadoYucatan( params ) {
      params.token = this.token;
      params.secret_key = environment.SECRET_KEY;

      const url = `${environment.URL_SERVICIOS}/user_registration_gov_customer?`;
  
  
      return this.http.post( url, params ).pipe(
                map( (resp: any) => {
                  return resp;
                }));
    }

    actualizaEmpleadoYucatan(id, params) {
      params.token = this.token;
      params.secret_key = environment.SECRET_KEY;
  
      const url = `${environment.URL_SERVICIOS}/gov_customer_update/update_gov_customer_info?token=${params.token}&secret_key=${environment.SECRET_KEY}`;
  
      return this.http.patch( url, params ).pipe(
        map( (resp: any) => { return resp;
        } ));
    }

    updateGovCustomer(id,contributor_id, params) {
      params.token = this.token;
      params.secret_key = environment.SECRET_KEY;
      const url = `${environment.URL_SERVICIOS}/contributors/${contributor_id}/gov_customers/${id}?token=${params.token}&secret_key=${environment.SECRET_KEY}`;
  
      return this.http.patch( url, params ).pipe(
        map( (resp: any) => { return resp;
        } ));
    }

    actualizaUsuarioRcPc(idu, params) {
      params.token = this.token;
      params.secret_key = environment.SECRET_KEY;
  
      const url = `${environment.URL_SERVICIOS}/users/${idu}?token=${params.token}&secret_key=${environment.SECRET_KEY}&auth[password]=${params.password}`;
  
      return this.http.patch( url, null ).pipe(
        map( (resp: any) => { return resp;
        } ));
      }

      getUsuarioRPWT( rpwt ) {

        const url = `${environment.URL_SERVICIOS}/get_reset_token?secret_key=${environment.SECRET_KEY}&reset_password_token=${rpwt}`;
    
        return this.http.get( url ).pipe(
        map( (resp: any) => {return this.crearArregloUsuario(resp);
        }));
    
        }

        crearArregloUsuario( usuariosObj: any) {
          const usuarios: any[] = [];
          const resul: any[] = [];
          if ( usuariosObj === null ) { return []; }
          Object.keys ( usuariosObj ).forEach( key => {
            const usuario: any = usuariosObj[key];
            usuarios.push( usuario );
          });
          resul.push( usuariosObj.data.attributes );
          return resul;  
        }

    getResetPaswword(email) {
      const url = `${environment.URL_SERVICIOS}/reset_password?email=${email}&secret_key=${environment.SECRET_KEY}`;
      return this.http.get( url ).pipe(
        map ( (resp: any) => { return (resp);
            } ));
        }   
        
        
        getResetPasswordToken(rtoken) {
          const url = `${this.path}/get_reset_pwd_token?reset_password_token=${rtoken}&secret_key=${environment.SECRET_KEY}`;
          return this.http.get( url ).pipe(
            map ( (resp: any) => { return (resp);
            } ));
        }

        confirmCredit(rtoken) {
          const token = rtoken;
          const url = `${this.path}/get_callback?call_back_token=${rtoken}`;
          return this.http.post( url, token)
        }

        declineCredit(rtoken) {
          const token = rtoken;
          const url = `${this.path}/get_callback_decline?call_back_token=${rtoken}`;
          return this.http.post( url, token)
        }

        getTokenStatus( token ) 
        {
          const rtoken = token;
          const url = `${this.path}/get_callback_token?call_back_token=${token}`;
          return this.http.post( url, {}).pipe(
          map( (resp: any) => { return (resp); 
          }));
      
          }

        fileToken( token ) 
        {
          const rtoken = token;
          const url = `${this.path}/file_callback?call_back_token=${token}`;
          return this.http.post( url, rtoken).pipe(
          map( (resp: any) => { return (resp); 
          }));
      
          }

        getComiteeTokenStatus( token ) 
        {
          const rtoken = token;
          const url = `${this.path}/get_comitee_callback_token?call_back_token=${token}`;
          return this.http.post( url, rtoken).pipe(
          map( (resp: any) => { return (resp); 
          }));
      
          }

          actualizaUsuarioPassWord( password,token ) {
            const url = `${this.path}/update_user_pwd?&password=${password}&reset_password_token=${token}`;
            return this.http.patch( url, null ).pipe(
              map( (resp: any) => { return resp;
              } ));
            }

        actualizaUsuarioRc(idu, params) {

          params.secret_key = environment.SECRET_KEY;
        
          const url = `${environment.URL_SERVICIOS}/users/${idu}?token=${params.token}&secret_key=${environment.SECRET_KEY}&auth[password]=${params.password}`;
        
          return this.http.patch( url, null ).pipe(
            map( (resp: any) => { return resp;
            } ));
          }    
      async fillLS(resp: any) {
        try {
          localStorage.setItem('uid', resp.data.attributes.id );
          localStorage.setItem('tkn', resp.data.token );
          localStorage.setItem('emailuser', resp.data.attributes.email );
          localStorage.setItem('nombreuser', resp.data.attributes.name );
          localStorage.setItem('expiratoken', resp.data.expires_at);
          localStorage.setItem('firmante', resp.data.attributes.company_signatory);
          localStorage.setItem('rid', resp.data.attributes.role_id);
          return true
        } catch (error) {
          
        }
        
      }

      getNipStatus( nip,customer ) 
      {        
        const rnip = nip;
        const url = `${environment.URL_SERVICIOS}/credit_bureaus/get_credit_bureau_nip_validation?id=${customer.id}&nip=${nip}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
        console.log(url);
        return this.http.post( url, rnip).pipe(
        map( (resp: any) => { return (resp); 
        }));
    
        }
        
      resetNip( customerId ) 
      {        
        // console.log("YA ESTAMOS DENTRO DEL SERVICIO RESET")
        // console.log(customerId)
        const id= customerId.id
        const rnip = customerId;
        const url = `${environment.URL_SERVICIOS}/credit_bureaus/reset_credit_bureau_nip?id=${id}&secret_key=${environment.SECRET_KEY}&token=${this.token}`;
        return this.http.post( url, rnip).pipe(
        map( (resp: any) => { return (resp); 
        }));
    
        }

        send_client_registration_mailer( nombre,correo,empresa,telefono,puesto ) {
          const url = `${this.path}/send_client_registration_mailer?&nombre=${nombre}&correo=${correo}&empresa=${empresa}&telefono=${telefono}&puesto=${puesto}`;
          return this.http.post( url, null ).pipe(
            map( (resp: any) => { return resp;
            } ));
          }
}
